//React
import React from 'react';

//Resource

//interfaces

//pages
import { SubmissionManagement } from 'pages/submissions';
import { useUserSubmissionManagementData } from './useUserSubmissionManagementData';

export const UserSubmissionManagement: React.FC = () => {
  const { submissions, payors, isLoading, isError, isFetching, errorMessage } =
    useUserSubmissionManagementData();
  return (
    <SubmissionManagement
      submissions={submissions}
      payors={payors}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
    />
  );
};
